import detectBrowserLanguage from 'detect-browser-language'

export function getBrowserLanguage () {
  let browserLang = detectBrowserLanguage()
  return browserLang ? browserLang.slice(0,2) : ''
}